import React from 'react';
import { Modal, Form, Input, Row, Col, Upload, Icon, Radio } from 'antd';


const VehiclesForm = Form.create({ name: 'form_in_modal' })(
  // eslint-disable-next-line
  class extends React.Component {

    onChangeLuggage = e => {
      this.props.form.setFieldsValue({
        lagguageAllowed:  e.target.value
      });
    }

    normFile = e => {
      console.log('Upload event:', e);
      if (Array.isArray(e)) {
        return e;
      }
      return e && e.fileList;
    };

    render() {
      const { visible, onCancel, onCreate, form, data } = this.props;
      const { getFieldDecorator } = form;

      return (
        <Modal
          visible={visible}
          title="Add Vehicle"
          okText="Save"
          onCancel={onCancel}
          onOk={onCreate}>

          <Form layout="vertical">
            <Row>
              <Col span={24}>
                <Form.Item >
                  {getFieldDecorator('vehiclePhoto', {
                    // valuePropName: 'fileList',
                    getValueFromEvent: this.normFile,
                  })(
                    <Upload.Dragger name="files" multiple={false} beforeUpload={()=>false}>
                      <p className="ant-upload-drag-icon">
                      <Icon type="car" theme="filled" />
                      </p>
                      <p className="ant-upload-text">Add Photo</p>
                    </Upload.Dragger>,
                  )}
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={8}>
                <Form.Item label="Vehicle Model">
                  {getFieldDecorator('vehicleModel', {
                    initialValue: data.vehicleModel,
                    rules: [{ required: true, message: 'Please input the Vehicle Model!' }],
                  })(<Input placeholder="e.g Toyota Spacio"/>)}
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item label="Number Plate">
                  {getFieldDecorator('numberPlate', {
                    initialValue: data.numberPlate,
                    rules: [{ required: true, message: 'Please input the Number Plate!' }],
                  })(<Input placeholder="e.g UBA 089G"/>)}
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item label="Color">
                  {getFieldDecorator('color', {
                    initialValue: data.color,
                    rules: [{ required: true, message: 'Please input the Color of the car!' }],
                  })(<Input placeholder="e.g Silver"/>)}
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <Form.Item label="What amount of luggage will you allow?">
                {getFieldDecorator('lagguageAllowed',{
                  initialValue: data.lagguageAllowed,
                })(<Radio.Group size="large"  onChange={this.onChangeLuggage}>
                        <Radio.Button value="No"> <Icon type="shopping" theme="filled" /> No Luggage</Radio.Button>
                        <Radio.Button value="Small"> <Icon type="shopping" theme="filled" /> Small</Radio.Button>
                        <Radio.Button value="Medium"> <Icon type="shopping" theme="filled" /> Medium</Radio.Button>
                        <Radio.Button value="Large"> <Icon type="shopping" theme="filled" /> Large</Radio.Button>
                    </Radio.Group>)}
                </Form.Item>
              </Col>
            </Row>

          </Form>
        </Modal>
      );
    }
  }
);

export default VehiclesForm;
